import { makeAutoObservable, runInAction } from "mobx";
import { PurchasesItemDto, SavePurchaseFormValues } from "../models/inventory";
import { Pagination, PagingParams } from "../models/pagination";
import agent from "../api/agent";


export default class InventoryPurchasesStore {
    loadingInitial = false;
    purchasesPredicate = new Map().set("all", true);
    purchasesRegistry = new Map<string | undefined, PurchasesItemDto>();
    purchasesPagingParams = new PagingParams();
    purchasesPagination: Pagination | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    setLoadingInitial = (val: boolean) => {
        this.loadingInitial = val;
    }

    setPurchasesPredicate = (predicate: string, value: string | undefined) => {
        if(value) this.purchasesPredicate.set(predicate, value);
        else this.purchasesPredicate.delete(predicate);
    }
    setPurchasesPagingParams = (val: PagingParams) => {
        this.purchasesPagingParams = val;
    }
    setPurchasesPagination = (val: Pagination) => {
        this.purchasesPagination = val;
    }
    setPurchasesItem = (value: PurchasesItemDto) => {
        this.purchasesRegistry.set(value.id, value);
    }
    get purchasesAxiosParams() {
        const params = new URLSearchParams();
        params.append("pageNumber", this.purchasesPagingParams.pageNumber.toString());
        params.append("pageSize", this.purchasesPagingParams.pageSize.toString());
        this.purchasesPredicate.forEach((value, key) => params.append(key, value));

        return params;
    }
    get getPurchases() {
        return Array.from(this.purchasesRegistry.values());
    }

    resetPredicate = () => {
        this.purchasesPredicate.clear();
        console.log(this.purchasesPredicate)
    }

    loadPurchases = async () => {
        this.loadingInitial = true;
        this.resetPurchasesRegistry();
        try {
            const result = await agent.inventoryPurchases.getPurchases(this.purchasesAxiosParams);
            runInAction(() => {
                result.data.forEach((dataItem: PurchasesItemDto) => this.setPurchasesItem(dataItem))
            });
            this.setPurchasesPagination(result.pagination);
            return result;
        } catch (error) {
            console.log(error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    updatePurchases = async (values: SavePurchaseFormValues[], poNumber: string) => {
        this.loadingInitial = true;
        try {
            await agent.inventoryPurchases.updatePurchases({ purchasesToSave: values, poNumber: poNumber });
        } catch (error) {
            console.log('error:', error);
        } finally {
            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    resetPurchasesRegistry = () => {
        this.purchasesRegistry.clear();
    }
}